export const PERMISSIONS = {
  MANAGER: 'manager',
  GLOBAL_ADMIN: 'global_admin',
  DASHBOARD: 'dashboard',
};
